import { useState } from "react";

interface SecretInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export default function SecretInput({
  value,
  onChange,
  placeholder,
}: SecretInputProps) {
  const [show, setShow] = useState(false);

  return (
    <div className="relative">
      <input
        type={show ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        spellCheck={false}
        className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 pr-11 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 transition"
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Masquer la clé" : "Afficher la clé"}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 hover:text-foreground-700 transition cursor-pointer"
      >
        <i className={show ? "ri-eye-off-line" : "ri-eye-line"}></i>
      </button>
    </div>
  );
}